import { Container, Dialog, Divider, IconButton } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import vehiclesApi from '../../api/vehicles.api'
import { ReactComponent as MotorcycleSvg } from '../../assets/motorcycle2.svg'
import { ReactComponent as AddSvg } from '../../assets/add_reverse.svg'
import { SessionContextStore, SESSION_ACTIONS } from '../../context/SessionContext'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import { BackButton } from '../Core/Buttons/BackButton'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { MotorcycleBlockView } from '../Motorcycle/MotorcycleBlockView'
import { MotorcycleForm } from '../Motorcycle/MotorcycleForm'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import CloseIcon from '@material-ui/icons/Close'
import { SkyPaper } from '../Core/Frames/SkyPaper'
import { ActionPaper } from '../Core/Frames/ActionPaper'
import { isMobile } from 'react-device-detect'
import { reportGTM } from '../Core/Utilities/GTagManger'
import { CustomErrorPopup } from '../PopUps/CustomErrorPopup'
import { set } from 'lodash'

export const CustomizeMotorcycle = () => {
  const sessionContext = React.useContext(SessionContextStore)
  const offerContext = React.useContext(BuyingInsuranceContextStore)
  const [error, setError] = React.useState('')
  const [motorEditState, setMotorState] = React.useState({ motor: {}, open: false })
  const [popUpErrorState, setPopUpErrorState] = React.useState({
    title: '',
    body: '',
    showPopUp: false,
    isEstimatedError: false,
    type: 'error',
  })

  const cancelErrorPopup = async () => {
    setPopUpErrorState({ open: false, title: '', body: '', type: 'error' })
    if (popUpErrorState.isEstimatedError) {
      setPopUpErrorState({ open: false, title: '', body: '', isEstimatedError: false, type: 'error' })
      openMotorcyleMissingEstimate()
    } else {
      setMotorState({ motor: {}, open: false })
    }

    await awaitWithLoading(sessionContext.loadUser())
  }

  const openMotorcyleMissingEstimate = () => {
    const vehiclesMissingEstimated = sessionContext.user.userVehicles.filter(veh => veh.estimated_mileage_value === 0)
    if (vehiclesMissingEstimated.length > 0) {
      setMotorState({
        motor: vehiclesMissingEstimated[0],
        open: true,
      })
    }
  }

  const onContinue = async () => {
    if (sessionContext.user.userVehicles.length > 0) {
      setError('')
      let res = await awaitWithLoading(vehiclesApi.motorcyclesDetailsNext())
      if (res.ok) {
        EventEmitterService.dispatch(EventKey.FLOW_CUSTOMIZE_VEHICLES_FINISH)
      } else {
        if (res.data.messages && res.data.title) {
          handleServerError(res.data)
        } else {
          EventEmitterService.dispatch(EventKey.ShowError, res)
        }
      }
    } else setError('Must add at least one motorcycle')
  }

  const addAnother = () => {
    setMotorState({ motor: { zip: sessionContext.user.zipCode, state: sessionContext.user.state }, open: true })
  }
  React.useEffect(() => {
    if (sessionContext.user.userVehicles.length === 0) addAnother()
  }, [])

  const onDeleteExistingVehicle = async values => {
    let res = await awaitWithLoading(vehiclesApi.deleteVehicle(values.id))
    if (res.ok) {
      await awaitWithLoading(sessionContext.loadUser())
    } else EventEmitterService.dispatch(EventKey.ShowError, res)
  }

  const handleServerError = error => {
    const allMessages = Object.values(error.messages)
    const isEstimatedError = Object.keys(error.messages).includes('EstimatedMileage')
    const isStateNotSupported = Object.keys(error.messages).includes('StateNotAvailable')

    setPopUpErrorState({
      title: error.title,
      body: allMessages.length > 0 ? allMessages[0] : '',
      showPopUp: true,
      isEstimatedError: isEstimatedError,
      type: isStateNotSupported ? 'information' : 'error',
    })
  }

  const SaveOrEdit = async motorcycle => {
    if (motorcycle.id == undefined) {
      let res = await awaitWithLoading(vehiclesApi.addVehicle(motorcycle))
      if (res.ok) {
        await awaitWithLoading(sessionContext.loadUser())
        setMotorState({ motor: {}, open: false })
        setError('')
        reportGTM('', '', { event: 'motorcycle-added-success' })
      } else {
        handleServerError(res.data)
      }
    } else {
      let res = await awaitWithLoading(vehiclesApi.updateVehicle(motorcycle))
      if (res.ok) {
        await awaitWithLoading(sessionContext.loadUser())
        setMotorState({ motor: {}, open: false })
      } else {
        handleServerError(res.data)
      }
    }
  }

  const onCloseDialog = async () => {
    // await awaitWithLoading(sessionContext.loadUser())
    setMotorState({ motor: {}, open: false })
  }

  return (
    <>
      <Container>
        <FlexView column>
          <FlexView vAlignContent={'center'}>
            <MotorcycleSvg style={{ height: '40px' }} className="margin-right-6" />
            <div className="text-title blue bold">Motorcycle Details</div>
          </FlexView>
          {isMobile ? <div className="margin-top-basic" /> : <Divider />}

          {sessionContext.user.userVehicles.map((motorcycle, index) => (
            <div key={index}>
              <ActionPaper
                deletable
                onDelete={() => onDeleteExistingVehicle(motorcycle)}
                onView={() => setMotorState({ open: true, motor: motorcycle })}
              >
                <MotorcycleBlockView motorcycle={motorcycle} />
              </ActionPaper>
              <br />
            </div>
          ))}
          <br />
          <BlueGrayBox className="fit-content" onClick={addAnother}>
            <FlexView vAlignContent={'center'} className="clickable fit-content">
              <AddSvg />
              <div className="text-body blue margin-left-6">
                Add {sessionContext.user.userVehicles.length == 0 ? 'a' : 'another'} motorcycle to your insurance
              </div>
            </FlexView>
          </BlueGrayBox>
          <br />
          {error && <div className="text-body red margin-bottom-basic">{error}</div>}
          <FlexView>
            <BackButton />
            <ContinueButton className="margin-left-12" onClick={onContinue} />
          </FlexView>
        </FlexView>

        <Dialog fullScreen fullWidth open={motorEditState.open}>
          <Container>
            <FlexView className="full-width" hAlignContent={'right'}>
              <IconButton onClick={onCloseDialog}>
                <CloseIcon />
              </IconButton>
            </FlexView>
            <br />
            <MotorcycleForm
              defaultValues={motorEditState.motor}
              state={sessionContext.user.state}
              SAVE_EVENT_KEY="on_health_statement_save"
              onSave={SaveOrEdit}
              billingFlowType={offerContext.billingFlowType}
            />
          </Container>
        </Dialog>
        <CustomErrorPopup
          title={popUpErrorState.title}
          body={popUpErrorState.body}
          open={popUpErrorState.showPopUp}
          onCancel={cancelErrorPopup}
          type={popUpErrorState.type}
        />
      </Container>
    </>
  )
}
